<!--
 * @Author: zhangminghao zhangminghao@wiz.top
 * @Date: 2024-12-11 10:51:06
 * @LastEditors: zhangminghao zhangminghao@wiz.top
 * @LastEditTime: 2024-12-11 11:54:12
 * @FilePath: \proj-shimen-ui\src\components\previewButton.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <el-button @click="preview" size="small">操作指南</el-button>
</template>
<script>
import DiyService from './services/DiyService'
export default {
  name: 'previewButton',
  props: {
    menuId: {
      type: String,
      default: '',
    },
  },
  data() {
    return {}
  },
  methods: {
    async preview() {
      console.log(this.menuId)
      if (!this.menuId) {
        return
      }
      const [err, res] = await DiyService.getTableData({
        TableName: 'diy_EntryGuide', // 录入指南模块
        _SearchEqual: {
          ModuleId: this.menuId, 
        },
      })
      if (!err && res.Code === 1 && res.Data?.length) {
        const url = `${window.VUE_APP_FILEPREVIEW_SERVER}/onlinePreview?url=${encodeURIComponent(
          window.wiz.V8.Base64.encode(`${window.wiz.SysConfig.FileServer}${res.Data[0].Attachment}`)
        )}`
        window.open(url, '_blank')
        return false
      } else {
        this.$message.error('未找到操作指南')
      }
    },
  },
}
</script>
